import React from 'react'

export const Gif = ({title, url}) => {

    return (
        <article className = "card">
            <img src={url} alt={title} />
        </article>
    )
}
